export default (population) => {
  if (population > 1000000) {
    return 800;
  } else if (population > 500000 && population <= 1000000) {
    return 600;
  } else if (population > 200000 && population <= 500000) {
    return 400;
  } else if (population > 100000 && population <= 200000) {
    return 200;
  } else if (population > 50000 && population <= 100000) {
    return 120;
  } else if (population > 20000 && population <= 50000) {
    return 95;
  } else if (population > 10000 && population <= 20000) {
    return 80;
  } else if (population > 5000 && population <= 10000) {
    return 60;
  } else if (population > 1000 && population <= 5000) {
    return 40;
  } else {
    return 40;
  }
};
